import React from 'react'
import { ResponsiveRadar } from '@nivo/radar'

// const data = [
//     {
//         "taste": "Modulo I",
//         "base-cemex": 6,
//         "NORESTE": 373,
//         "Centro": 513,
//         "PACIFICO": 1143,
//         "TESTING": 62,
//         "SURESTE": 535
//     },
//     {
//         "taste": "Modulo II",
//         "base-cemex": 5,
//         "NORESTE": 274,
//         "Centro": 422,
//         "PACIFICO": 772,
//         "TESTING": 6,
//         "SURESTE": 385
//     },
//     {
//         "taste": "Modulo III",
//         "base-cemex": 4,
//         "NORESTE": 242,
//         "Centro": 252,
//         "PACIFICO": 520,
//         "TESTING": 8,
//         "SURESTE": 288
//     },
//     {
//         "taste": "Modulo IV",
//         "base-cemex": 5,
//         "NORESTE": 301,
//         "Centro": 342,
//         "PACIFICO": 577,
//         "SURESTE": 322
//     }
// ]
export const CardBarRadar = ({ info }) => {
    const data = [];
    if (info && info.size > 0) {
    // console.log([...info.keys()])
    ["Modulo I","Modulo II","Modulo III","Modulo IV"].forEach(key => {
        const obj = {
          "taste":`` + key + ``,
        }
        info.forEach((value, key2) => {
            if (key === "Modulo I" && value.M1_L6) {
                obj[key2] = value.M1_L1.corrects + value.M1_L1.incorrects + value.M1_L2.corrects + value.M1_L2.incorrects + value.M1_L3.corrects + value.M1_L3.incorrects + value.M1_L4.corrects + value.M1_L4.incorrects + value.M1_L5.corrects + value.M1_L5.incorrects + value.M1_L6.corrects + value.M1_L6.incorrects
            } else if (key === "Modulo I" && !value.M1_L6) {
                obj[key2] = 0
            }
            if (key === "Modulo II" && value.M2_L5) {
                obj[key2] = value.M2_L1.corrects + value.M2_L1.incorrects + value.M2_L2.corrects + value.M2_L2.incorrects + value.M2_L3.corrects + value.M2_L3.incorrects + value.M2_L4.corrects + value.M2_L4.incorrects + value.M2_L5.corrects + value.M2_L5.incorrects
            } else if (key === "Modulo II" && !value.M2_L5) {
                obj[key2] = 0
            }
            if (key === "Modulo III" && value.M3_L4) {
                obj[key2] = value.M3_L1.corrects + value.M3_L1.incorrects + value.M3_L2.corrects + value.M3_L2.incorrects + value.M3_L3.corrects + value.M3_L3.incorrects + value.M3_L4.corrects + value.M3_L4.incorrects
            } else if (key === "Modulo III" && !value.M3_L4) {
                obj[key2] = 0
            }
            if (key === "Modulo IV" && value.M4_L5) {
                obj[key2] = value.M4_L1.corrects + value.M4_L1.incorrects + value.M4_L2.corrects + value.M4_L2.incorrects + value.M4_L3.corrects + value.M4_L3.incorrects + value.M4_L4.corrects + value.M4_L4.incorrects + value.M4_L5.corrects + value.M4_L5.incorrects
            } else if (key === "Modulo IV" && !value.M4_L5) {
                obj[key2] = 0
            }
        })
        data.push(obj)
      })
    }
  return (
      <div className="w-[504px] h-[432px] bg-white rounded-2xl shadow-sm p-4 text-center">
          <p className="text-black font-semibold text-sm">Comparativa de repeticiones por grupo</p>
        <ResponsiveRadar
        data={data}
              //   keys={["Centro", "NORESTE", "PACIFICO", "SURESTE", "base-cemex"]}
              keys={info ? [...info.keys()] : [""]}
        indexBy="taste"
        valueFormat=">-.2f"
        margin={{ top: 40, right: 15, bottom: 30, left: 50 }}
        borderColor={{ from: 'color' }}
       
        dotSize={7}
        dotColor={{ theme: 'background' }}
        dotBorderWidth={2}
        colors={{ scheme: 'nivo' }}
        blendMode="multiply"
        motionConfig="wobbly"
        legends={[
            {
                anchor: 'top-left',
                direction: 'column',
                translateX: -50,
                translateY: -40,
                itemHeight: 20,
                itemTextColor: '#999',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
    />
    </div>
  )
}
